import React, {Component} from "react"

import Link from "../../utils/link"

import Slider from 'react-slick'

import "./HeroSection.scss"

import { FaCaretLeft, FaCaretRight } from "react-icons/fa"

function PrevArrow(props) {
  let { onClick, style, className } = props
  let attr = { onClick, style, className }
  return (
    <span
      {...attr}
    >
      <FaCaretLeft />
    </span>
  )
}

function NextArrow(props) {
  let { onClick, style, className } = props
  let attr = { onClick, style, className }
  return (
    <span
      {...attr}
    >
      <FaCaretRight />
    </span>
  )
}

class HeroSection extends Component {

  state = {
    activeSlide: 0,
  }

  render() {

    const { title, button, backgroundImage, slider } = this.props
    let { activeSlide } = this.state
    const settings = {
      speed: 900,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      fade: true,
      cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      pauseOnHover: false,
      focusOnSelect: false,
      draggable: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      beforeChange: (current, next) => this.setState({ activeSlide: next }),
    }

    return (
      <section className="hero-section">
        <Slider className='hero-section__slider' {...settings}>
          { slider.map((el, i) => <img src={el.localFile.publicURL} alt={el.altText} key={i} />) }
        </Slider>
        <div className="hero-section__container">
          <div className="hero-section__container__heading">
            { title || 'Discover the best of Magnetic Island' }
          </div>
          { button &&
            <Link to={button.link} className="hero-section__container__booking-btn">
              { button.text }
            </Link>
          }
        </div>
      </section>
    )
  }
}

export default HeroSection
